// @ts-strict-ignore
import { A11yMenu } from "@aviary";
import { CertPendingReviewWrapper } from "@clinic/shared/components/CertPendingReviewWrapper/CertPendingReviewWrapper";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { useUserIdQuery } from "@shared/data/queries/UserIdQuery/UserId.query";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { useLocation } from "@shared/react-router-dom/react-router-dom";
import { StorePlatform } from "@shared/types/StorePlatform";

import { EmersonMobileNav } from "./EmersonMobileNav/EmersonMobileNav";
import { Navigation } from "./Navigation/Navigation";

import * as styles from "./Header.styles";

const Header = () => {
  const { pathname } = useLocation();
  const isOnboardingPage = pathname.indexOf(emersonRoutes.onboarding) > -1;

  const { isUnauthenticated } = useSharedGlobalConfig();
  const { data, loading } = useUserIdQuery({
    skip: isUnauthenticated,
  });

  const renderOnboardingBars = () => {
    if (isUnauthenticated || isOnboardingPage) return null;

    return (
      <div css={styles.barWrapper}>
        <CertPendingReviewWrapper storePlatform={StorePlatform.EMERSON} />
      </div>
    );
  };

  return (
    <>
      <A11yMenu />
      <div id="PageHeader">
        <Navigation loading={loading} data={data} />
      </div>
      <EmersonMobileNav />
      {renderOnboardingBars()}
    </>
  );
};

export { Header };
